export default {
  BusinessOrderAuditCom: {
    skuTitle: 'Summary by commodity',
    skuItemTitle: 'Detail by commodity line',
    hangUp: 'Hang up',
    confirmTextHangUp: 'Whether to confirm the suspension？',
    hang: 'Liberation',
    confirmTextHang: 'Are you sure to unlink？',
    receipt: 'confirm the receipt of goods',
    confirmTextReceipt: 'Whether to confirm receipt？',
    blackAndWhiteList: 'Set black and white list'
  },
  BusinessOrderAuditComSkuList: {
    receivingStatus: 'Receipt status',
    deliveryStatus: 'Delivery status',
    preemptionStatus: 'Reservation Status',
    sourceStatus: 'Sourcing Status',
    suspendStatus: 'Suspend Status',
    syncPreempStatus: 'preempt writeback state',
    syncDeliveryStatus: 'Shipping writeback status',
    receipt: 'Confirm the receipt of goods',
    hangUp: 'Hang up',
    hang: 'Liberation',
    cover: 'cover',
    giftFlag: 'Is it a gift',
    quantity: 'Quantity',
    thirdSaleAmount: 'Three-party platform sales unit price',
    outBalancePrice: 'Three-party platforms share the total price equally',
    innerSalePrice: 'Internal sales price',
    innerBalancePrice: 'Internally apportioned total price',
    costAmount: 'Cost Price',
    totalCostAmount: 'Total cost',
    transPrice: 'Shipping cost',
    msgWarning: 'The returned data is empty, please contact the administrator',

  }
};
